export const ListStatus = ({
  variant = 'initial',
}: {
  variant?: 'initial' | 'empty';
}) => {
  return (
    <div className="flex flex-col items-center h-full justify-center text-[#9CA5AC] text-sm">
      {variant === 'initial'
        ? 'Введите название товара'
        : 'Нет подходящих результатов'}
    </div>
  );
};
